import React from "react";
import {
  Activity,
  Bot,
  Calendar,
  Shield,
  Radio,
  Dna,
  Users
} from "lucide-react";

import Navigation from "../components/Navigation";
import FooterSection from "../components/FooterSection";
import "./Features.css";

const Features = () => {
  const featuresMatrix = [
    {
      icon: Activity,
      title: "Real-Time Vitals Monitoring",
      desc: "Track patient vitals instantly using connected IoT devices.",
      num: "01"
    },
    {
      icon: Bot,
      title: "AI Assistance",
      desc: "Get instant help for medical processes and system usage.",
      num: "02"
    },
    {
      icon: Calendar,
      title: "Appointment Booking",
      desc: "Book and manage doctor appointments easily.",
      num: "03"
    },
    {
      icon: Shield,
      title: "Secure Data",
      desc: "Your data is protected with strong encryption.",
      num: "04"
    },
    {
      icon: Radio,
      title: "Emergency Alerts",
      desc: "Automatic alerts sent when vitals go critical.",
      num: "05"
    },
    {
      icon: Users,
      title: "Caregiver Access",
      desc: "Allow caregivers to monitor patient health.",
      num: "06"
    }
  ];

  return (
    <div className="features-portal">
      <Navigation />

      <div className="feat-particle-field"></div>
      <div className="feat-grid-overlay"></div>

      <main className="feat-content">
        <header className="feat-hero">
          <div className="feat-hud-badge">
            <Dna size={14} />
            <span>V1.5.1</span>
          </div>

          <h1>
            Platform <span className="text-gradient">Features</span>
          </h1>

          <p>
            Medico.in provides a complete system for smart healthcare monitoring.
          </p>
        </header>

        <section className="feat-matrix">
          {featuresMatrix.map((feat, index) => {
            const Icon = feat.icon;
            return (
              <div key={index} className="feat-tile">
                <span className="feat-tile-number">{feat.num}</span>

                <div className="feat-tile-icon">
                  <Icon size={32} />
                </div>

                <h3>{feat.title}</h3>
                <p>{feat.desc}</p>
              </div>
            );
          })}
        </section>
      </main>

      <FooterSection />
    </div>
  );
};

export default Features;